import IuCarouselItem from '../Carousel/src/item';

export default IuCarouselItem;
